/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  List,
  OpenAPISpec,
  OpenAPISpecSlug,
  OpenAPISpecSource,
  OpenAPISpecVisibility,
} from "./data-contracts";

/**
 * No description
 * @tags openapi
 * @name ListOpenApiSpecs
 * @summary List all OpenAPI spec
 * @request GET:/orgs/{organizationId}/openapi
 * @secure
 */

// @ts-ignore
export const listOpenAPISpecs: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OpenAPISpec[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/openapi",
  method: "get",
  streaming: false,
  tags: ["openapi"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Adds an OpenAPI spec to the organization, from a URL or from its text. The spec is processed asynchronously and no page is created: to publish its API reference in a space, insert a page that renders it with an `insert_computed_page` change, through the `updateChangeRequestContent` operation. That reference fills in once processing completes and is regenerated each time the spec is updated.
 * @tags openapi
 * @name CreateOpenApiSpec
 * @summary Create an OpenAPI spec
 * @request POST:/orgs/{organizationId}/openapi
 * @secure
 */

// @ts-ignore
export const createOpenAPISpec: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** Slug used as reference */
    slug: OpenAPISpecSlug;
    /** Create a specification from an URL */
    source: OpenAPISpecSource;
  };
  RequestHeaders: {};
  ResponseBody: OpenAPISpec;
  ResponseStatusCode: 201 | 400;
} = {
  route: "/orgs/{organizationId}/openapi",
  method: "post",
  streaming: false,
  tags: ["openapi"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi
 * @name GetOpenApiSpecBySlug
 * @summary Get an OpenAPI spec by its slug
 * @request GET:/orgs/{organizationId}/openapi/{specSlug}
 * @secure
 */

// @ts-ignore
export const getOpenAPISpecBySlug: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OpenAPISpec;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}",
  method: "get",
  streaming: false,
  tags: ["openapi"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Creates the organization's OpenAPI spec with this slug, or replaces its source with a new version. The spec is processed asynchronously, and pages that already render it are regenerated once it is. Creating a spec adds no page: to publish its API reference in a space, insert a page that renders it with an `insert_computed_page` change, through the `updateChangeRequestContent` operation.
 * @tags openapi
 * @name CreateOrUpdateOpenApiSpecBySlug
 * @summary Create or update an OpenAPI spec
 * @request PUT:/orgs/{organizationId}/openapi/{specSlug}
 * @secure
 */

// @ts-ignore
export const createOrUpdateOpenAPISpecBySlug: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Create a specification from an URL */
    source: OpenAPISpecSource;
  };
  RequestHeaders: {};
  ResponseBody: OpenAPISpec;
  ResponseStatusCode: 200 | 201 | 400;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}",
  method: "put",
  streaming: false,
  tags: ["openapi"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi
 * @name UpdateOpenApiSpecBySlug
 * @summary Update OpenAPI spec visibility
 * @request PATCH:/orgs/{organizationId}/openapi/{specSlug}
 * @secure
 */

// @ts-ignore
export const updateOpenAPISpecBySlug: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * The visibility setting of the OpenAPI spec.
     * * `private`: The spec is not publicly available.
     * * `public`: The spec is available to anyone with a public link.
     */
    visibility: OpenAPISpecVisibility;
  };
  RequestHeaders: {};
  ResponseBody: OpenAPISpec;
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}",
  method: "patch",
  streaming: false,
  tags: ["openapi"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi
 * @name DeleteOpenApiSpecBySlug
 * @summary Delete an OpenAPI spec
 * @request DELETE:/orgs/{organizationId}/openapi/{specSlug}
 * @secure
 */

// @ts-ignore
export const deleteOpenAPISpecBySlug: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}",
  method: "delete",
  streaming: false,
  tags: ["openapi"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
